module.exports = "https://cdn-social.hiplatform.com/images/8417404c00e38495df3c02b2a3f8cdf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/thinking.svg
// module id = Zi2G
// module chunks = 0